import { icons, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
export var INSURERS_VIEW_OPTIONS = [
    {
        active: false,
        icon: {
            icon: icons.List,
        },
        id: "1",
        name: "List",
    },
    {
        active: true,
        icon: {
            icon: icons.GridView,
        },
        id: "2",
        name: "GridView",
    },
];
export var SPONSOR_SELECT_OPTIONS = [
    {
        id: "1",
        name: "Banesco",
        value: "1",
    },
];
